import { createSlice } from "@reduxjs/toolkit";
import { getPricingRegionsHospitals } from "../actions/pricingDashboard.action";

const initialState = {
  isLoading: false,
  isError: false,
  data: {
    body: {
      regions: [],
      hospital_systems: [],
      hospitals: [],
    },
  },
};

const pricingRegionsHospitals = createSlice({
  name: "Get Regions and hospitals Filters",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPricingRegionsHospitals.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getPricingRegionsHospitals.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      if (!action?.payload) state.isError = true;
      else state.isError = false;
    });

    builder.addCase(getPricingRegionsHospitals.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default pricingRegionsHospitals.reducer;
